import { Component, OnInit } from "@angular/core";
import { VenueService } from "../venue.service";
import { PitchData } from "../../shared/model/pitch";
import { SportToPitchCourtTextPipe } from "../../pipe/sport-to-pitch-court-text.pipe";
import { SportFormatSurfaceTextPipe } from "../../pipe/sport-format-surface-text.pipe";
import { ViewportService } from "../viewport.service";
import { filter } from "rxjs/operators";

@Component({
    selector: "mlp-carousel",
    templateUrl: "carousel.component.html",
    styleUrls: ["./carousel.component.scss"],
})
export class CarouselComponent implements OnInit {
    public prevBackgroundImage: string;
    public currBackgroundImage: string;
    public nextBackgroundImage: string;
    public currentIndex = 0;
    public totalImages = 0;

    constructor(
        public venueService: VenueService,
        private sportToPitchCourtTextPipe: SportToPitchCourtTextPipe,
        private sportFormatSurfaceText: SportFormatSurfaceTextPipe,
        private viewportService: ViewportService,
    ) {
        this.venueService.pitchDataChange.subscribe(() => {
            this.reset();
        });
        this.viewportService.viewType$
            .pipe(filter(_ => !!this.venueService.pitchData))
            .subscribe(size => {
                this.setPrevNextImages(this.venueService.pitchData, size)
            })
    }

    ngOnInit() {
        this.reset();
    }

    imageAltTag() {
        let text = "";

        if (this.venueService.pitchData) {
            let formatSurfaceText = this.sportFormatSurfaceText.transform(
                this.venueService.pitchData.data
            );

            text += this.venueService.pitchData.data.attributes.name + " ";

            if (
                formatSurfaceText !=
                this.venueService.pitchData.data.attributes.sport
            ) {
                text += formatSurfaceText + " ";
            }

            text += this.sportToPitchCourtTextPipe
                .transform(
                    this.venueService.pitchData.data.attributes.sport,
                    ""
                )
                .toLowerCase();
        }

        return text;
    }

    private reset() {
        if (this.venueService.pitchData) {
            this.totalImages =
                this.venueService.pitchData.data.attributes.images.large.length;
            this.currentIndex = 0;
            this.setPrevNextImages(this.venueService.pitchData);
        }
    }

    public prev() {
        if (this.currentIndex - 1 < 0) {
            this.currentIndex = this.totalImages - 1;
        } else {
            this.currentIndex--;
        }

        this.setPrevNextImages(this.venueService.pitchData);
    }
    public next() {
        if (this.totalImages == this.currentIndex + 1) {
            this.currentIndex = 0;
        } else {
            this.currentIndex++;
        }

        this.setPrevNextImages(this.venueService.pitchData);
    }

    private setPrevNextImages(pitchData: PitchData, size = 'large') {
        this.currBackgroundImage =
            pitchData.data.attributes.images[size][this.currentIndex];

        let next = this.currentIndex + 1;

        if (
            this.totalImages == this.currentIndex + 1 ||
            this.totalImages == 1
        ) {
            next = 0;
        }

        this.nextBackgroundImage = this.backgroundImage(
            pitchData.data.attributes.images[size][next]
        );

        let previous = this.currentIndex - 1;

        if (this.currentIndex - 1 < 0) {
            previous = this.totalImages - 1;
        }

        this.prevBackgroundImage = this.backgroundImage(
            pitchData.data.attributes.images[size][previous]
        );
    }

    private backgroundImage(image: string) {
        return "url(" + image + ")";
    }
}
